    <h2 mat-dialog-title>Error Summary</h2>
    <mat-dialog-content>
      <mat-accordion>
        <mat-expansion-panel *ngFor="let error of data.errors">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Row {{ error.row }}, Column {{ error.column }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{ error.message }}</p>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close()">Close</button>
    </mat-dialog-actions>